import { Pipe, PipeTransform } from '@angular/core';
import { PortfolioManagement } from '../models/portfolioManagement.model';
@Pipe({
  name: 'secondPolicyFilter'
})
export class SecondPolicyFilterPipe implements PipeTransform {
  transform(items: PortfolioManagement[], searchBranch: any, searchPolicy: any, searchOffice: any, searchAnnxed: any): any[] {
    let args: Array<any> = [searchBranch, searchPolicy, searchOffice, searchAnnxed];

    if (!items) return [];

    for (let i = 0; i < args.length; i++) {
      if (!args[i]) return items;
      args[i].toLowerCase().replace(/[\W_]/g, '');
    }
        
    return items.filter(it => {

      for (let i = 0; i < args.length; i++) {
        for (let j = 0; i < args.length; j++) {
          console.log(it.idPortfolio.toString().toLowerCase().includes(args[i]) ||
            it.idPortfolio.toString().toLowerCase().includes(args[j]));
          return it.idPortfolio.toString().toLowerCase().includes(args[i]) ||
            it.idPortfolio.toString().toLowerCase().includes(args[j]);
        }
      }
    });
  }

  //transform(items: PortfolioManagement[], args[]: any): any[] {
  //  if (!items) return [];

  //  for (i = 0; i > args.length; i++) {

  //  if (!searchBranch && !searchPortfolio && !searchOffice && !searchAnnexed) return items;
  //  }

  //  if (typeof searchBranch !== 'undefined') searchBranch = searchBranch.toLowerCase().replace(/[\W_]/g, '');
  //  if (typeof searchPortfolio !== 'undefined') searchPortfolio = searchPortfolio.toLowerCase().replace(/[\W_]/g, '');
  //  if (typeof searchOffice !== 'undefined') searchOffice = searchOffice.toLowerCase().replace(/[\W_]/g, '');
  //  if (typeof searchAnnexed !== 'undefined') searchAnnexed = searchAnnexed.toLowerCase().replace(/[\W_]/g, '');
    
  //  return items.filter(it => {

  //    return it.idPortfolio.toString().toLowerCase().includes(searchBranch) ||
  //          it.idPortfolio.toString().toLowerCase().includes(searchPortfolio) ||
  //          it.idPortfolio.toString().toLowerCase().includes(searchOffice) ||
  //          it.idPortfolio.toString().toLowerCase().includes(searchAnnexed);
  //  });
  // }
}
